import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_get_first_warehouseService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: {  }): 
  Promise<{ result: { Id?: number, Name?: string, WarehousesContactsLookup?: { ContactId?: number, Contact?: { FirstName?: string, LastName?: string, PrimaryEmail?: string, PrimaryTelephone?: string, Address?: { AttentionOf?: string, City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string } } }[] } }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = null;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      }) {
      return false;
    }
}
